{
    "local": "http://localhost:8100",
    "dev": "https://brand-api-qa.jfit.co",
    "qa": "https://brand-api-staging.jfit.co",
    "production": "https://brand-api.jfit.co"
}
